'use strict';

var Caml_obj = require("bs-platform/lib/js/caml_obj.js");

function scrollToBottom(qs) {
  var ele = document.querySelector(qs);
  if (!(ele == null)) {
    ele.scrollTop = ele.scrollHeight;
    return ;
  }
  
}

function toggleClassToSiblings(qs, className, target) {
  var elements = document.querySelectorAll(qs);
  elements.forEach(function (ele, i) {
        if (Caml_obj.caml_equal(ele, target)) {
          console.log("true");
        } else {
          console.log("false");
        }
        
      });
  
}

exports.scrollToBottom = scrollToBottom;
exports.toggleClassToSiblings = toggleClassToSiblings;
/* No side effect */
